/** @format */

import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ResultModal from "../../Common/ResultModal";
import AddProductModal from "../../Common/AddProductModal";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as dateHelper from "../../../Helpers/DateHelper";
import cellEditFactory from "react-bootstrap-table2-editor";
import { priceChangeService } from "../../../Services/AccountingServices/priceChange.service";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import SpinnerLoading from "../../Common/SpinnerLoading";
import ActionModal from "../../Common/ActionModal";
import ProductsFilterModal from "../../Common/ProductsFilterModal";
import { AuthContext } from "../../../Contexts/AuthContext";

const DocumentDetails = (props) => {
  const { useAccounting } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [update, setUpdate] = useState(new Date());
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [modalValidationMsg, setModalValidationMsg] = useState("");
  const [initValue, setInitValue] = useState({
    date: null,
    storeId: 0,
    storeName: "",
    note: "",
    priceListId: null,
    documentNumber: null,
    priceChangeDocumentGuid: "",
    startDate: "",
    endDate: "",
  });

  const [actionModal, setActionModal] = useState({
    title: "",
    text: "",
    show: false,
    confirmBtn: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });
  const addFilterProducts = (filterProducts) => {
    let newArr = [...products];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      products.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false
      )
    );

    let oldDeleted2 = oldDeleted.filter((f) =>
      filterProducts.some((item) => item.productGuid === f.productGuid)
    );

    //vraćam ih na isActive true
    oldDeleted2.forEach((el) => (el.isActive = true));

    //uklanjanje duplikata
    oldDeleted = oldDeleted.filter((f) =>
      oldDeleted2.some((item) => item.productGuid !== f.productGuid)
    );

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid)
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);

    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid)
    );

    let newProducts = addedProducts.map((prod) => ({
      priceChangeDetailGuid: prod.priceChangeDetailGuid,
      productGuid: prod.productGuid,
      productName: prod.productName,
      oldPrice: prod.price,
      newPrice: Number(prod.price),
      isActive: true,
    }));

    newArr = newArr.concat(newProducts);

    let shouldRemove = newArr.filter(
      (e) => e.priceChangeDetailGuid === undefined && e.isActive === false
    );

    newArr = newArr.filter((el) => !shouldRemove.includes(el));

    setIsDisabled(false);
    setProducts(newArr);
  };

  const addNewProduct = (productGuid, productName, price) => {
    setProducts([
      ...products,
      {
        priceChangeDetailGuid: null,
        productGuid,
        productName,
        oldPrice: price,
        newPrice: 0,
        isActive: true,
      },
    ]);
    setIsDisabled(false);
  };

  const onSubmit = (data) => {
    priceChangeService
      .documentUpdate(
        initValue.priceChangeDocumentGuid,
        initValue.storeId,
        initValue.date,
        initValue.startDate,
        initValue.endDate,
        data.note,
        products
      )
      .then((res) => {
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateSuccess-Title",
            text: "InitialState-ResultModal-UpdateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleClose = () => {
    setModal({ ...modal, show: false });
    if (modal.success) {
      history.push("/price-change");
    }
  };
  const handleCancel = () => {
    history.goBack();
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");

    priceChangeService
      .getDocumentById(props.match.params.documentId)
      .then((res) => {
        if (res.data.data !== null) {
          setInitValue({
            ...initValue,
            date: res.data.data.documentDate,
            documentNumber: res.data.data.documentNumber,
            note: res.data.data.note,
            priceListId: res.data.data.priceListId,
            storeId: Number(res.data.data.storeId),
            storeName: res.data.data.storeName,
            tenantId: res.data.data.tenantId,
            startDate: res.data.data.startDate,
            endDate: res.data.data.endDate,
            priceChangeDocumentGuid: res.data.data.priceChangeDocumentGuid,
          });
        }
        priceChangeService
          .documentDetails(props.match.params.documentId)
          .then((res) => {
            setProducts(res.data.data);
            setIsLoading(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => err);
  }, [update]);

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const handleLockDocument = () => {
    setActionModal({
      title: "InitialState-DocumentLock-Title",
      text: "InitialState-DocumentLock-Text",
      confirmBtn: "Confirm-Lock",
      confirmAction: confirmLock,
      show: true,
    });
  };

  const handleDeleteDocument = () => {
    setActionModal({
      title: "InitialState-DocumentDelete-Title",
      text: "InitialState-DocumentDelete-Text",
      confirmBtn: "Confirm-Delete",
      confirmAction: confirmDelete,
      show: true,
    });
  };

  const handleHideActionModal = () =>
    setActionModal({ ...actionModal, show: false });

  const confirmLock = () => {
    priceChangeService
      .documentLock(props.match.params.documentId)
      .then((res) => {
        setActionModal({ ...modal, show: false });
        if (res && res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockSuccess-Title",
            text: "InitialState-ResultModal-LockSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockError-Title",
            text: "InitialState-ResultModal-LockError-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const confirmDelete = () => {
    priceChangeService
      .documentDelete(props.match.params.documentId)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        if (data.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteSuccess-Title",
            text: "InitialState-ResultModal-DeleteSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteError-Title",
            text: "InitialState-ResultModal-DeleteError-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "InitialState-ResultModal-DeleteError-Title",
          text: "InitialState-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const options = {
    sizePerPage:10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const { SearchBar } = Search;

  function currencyFormatter(cell) {
    if (typeof cell === "string" && cell.includes(",")) {
      cell = cell.replace(/,/g, ".");
    }
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      hidden: initValue.documentNumber ? true : false,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          let newArr = [...products];
          let item = newArr.find((p) => p.productGuid === row.productGuid);
          item.isActive = false;

          setProducts(newArr);
          setIsDisabled(false);
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
      editable: false,
    },
    {
      dataField: "oldPrice",
      text: translator("PriceChange-oldPrice"),
      editable: false,
      formatter: currencyFormatter,
    },
    {
      dataField: "newPrice",
      editable: initValue.documentNumber ? true : false,
      text: `${translator("PriceChange-newPrice")}*`,
      editable: true,
      formatter: currencyFormatter,
      validator: (newValue, row, column) => {
        if (newValue.includes(",")) {
          newValue = parseFloat(newValue.replace(/,/g, "."));
        }

        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("PriceNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("PriceMaxTenThousand"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
  ];

  return (
    <>
      <CardWrap subtitle={translator("DocumentDetails")}>
        {!isLoading ? (
          <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-IndexData")}
                </legend>
                <div className="form-group">
                  <div>
                    <label className="boldedDocNumber">
                      <b>{translator("InitialState-DocumentNumber")}:</b>{" "}
                      {initValue.documentNumber
                        ? initValue.documentNumber
                        : translator("Document-NotLocked")}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Date")}:</b>{" "}
                      {dateHelper.formatUtcToDate(initValue.date)}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Store")}:</b>{" "}
                      {initValue.storeName}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-DateFrom")}:</b>{" "}
                      {dateHelper.formatUtcToDate(initValue.startDate)}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-DateTo")}:</b>{" "}
                      {dateHelper.formatUtcToDate(initValue.endDate)}
                    </label>
                  </div>
                  <div className="form-group">
                    <label>
                      <b>{translator("InitialState-Note")}:</b>
                    </label>
                    <textarea
                      name="note"
                      ref={register({ maxLength: 250 })}
                      className="form-control"
                      rows={4}
                      id="textArea"
                      defaultValue={initValue.note}
                      onChange={() => setIsDisabled(false)}
                      disabled={initValue.documentNumber ? true : false}
                    ></textarea>
                    {errors.note && errors.note.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength250")}
                      </p>
                    )}
                  </div>
                </div>
              </fieldset>
              <div
                class="custom-card-footer row"
                style={{ borderTop: "1px solid #ccc", paddingTop: "22px" }}
              >
                <label class="control-label col-md-12">
                  * {translator("DangerArea")}
                </label>
                <div className="col-md-6">
                  <button
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-outline-secondary btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLockDocument();
                    }}
                  >
                    {translator("Btn-Conclude")}
                  </button>
                </div>

                <div className="col-md-12 mt-3">
                  <button
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-danger btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDeleteDocument();
                    }}
                  >
                    {translator("Btn-RemoveDoc")}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-Items")}
                </legend>
                <ToolkitProvider
                  keyField="productGuid"
                  data={products.filter((item) => item.isActive === true)}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <>
                      {!initValue.documentNumber ? (
                        <div className="form-group">
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowFilterModal(true);
                            }}
                          >
                            <span className="icon icon-filter"></span>{" "}
                            {translator("Filter")}
                          </button>
                          &nbsp;
                          {/* <button
                            className="btn btn-primary"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowProductModal(true);
                            }}
                          >
                            {translator("InitialState-AddProduct")}
                          </button> */}
                          <span className="text-danger ml-2">
                            {translator(modalValidationMsg)}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="form-group">
                        <SearchBar
                          {...props.searchProps}
                          placeholder={translator("Search")}
                          className="col-md-12"
                        />
                      </div>

                      <hr />
                      <BootstrapTable
                        {...props.baseProps}
                        noDataIndication={translator("No-Data")}
                        pagination={paginationFactory(options)}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                        })}
                      />
                      <p>
                        <span className="editableColumns">*</span>
                        {translator("EditableTableColumns")}
                      </p>
                    </>
                  )}
                </ToolkitProvider>
              </fieldset>
            </div>
            <div
              className="container-fluid mt-4"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={handleCancel}
              >
                {translator("POS-New_EditPOS-Close")}
              </button>
              &nbsp;
              <button
                className="btn btn-primary"
                disabled={isDisabled}
                type="submit"
              >
                {translator("POS-New_EditPOS-Save")}
              </button>
            </div>
          </form>
        ) : (
          <SpinnerLoading />
        )}
      </CardWrap>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      <ActionModal
        show={actionModal.show}
        handleHide={handleHideActionModal}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
      {initValue.date !== null && (
        <ProductsFilterModal
          show={showFilterModal}
          storeId={initValue.storeId}
          documentOption={1}
          prodList={products.filter((item) => item.isActive === true)}
          handleHide={() => setShowFilterModal(false)}
          confirmAdd={addFilterProducts}
        />
      )}
      {initValue.date !== null && (
        <AddProductModal
          show={showProductModal}
          tenantId={initValue.tenantId}
          priceListId={initValue.priceListId}
          addNewProduct={addNewProduct}
          handleHide={() => setShowProductModal(false)}
        />
      )}
    </>
  );
};

export default DocumentDetails;
